import { SetupUserFormState } from '@Forms/users/SetupUserFormContext';
import { UpdateRequest } from '@contracts/api/dto/common/UpdateRequest';
import { UserItemDto } from '@contracts/api/dto/users/UserDto';

export const useSetupUserUseCaseMapper = (user: UserItemDto) => {
  return {
    toFormState: async (): Promise<SetupUserFormState | undefined> => {
      return {
        allowedRoleIds: user?.allowedRoleIds || [],
        password: user?.password || '',
        providerRgs:
          user?.providerRgs?.map((pr) => ({
            rgsId: pr.rgsId,
            providerIds: pr.providerIds ?? [],
          })) ?? [],
        email: user?.email || '',
        roleIds: user?.roleIds || [],
        isProviderUsersAdmin: user?.isProviderUsersAdmin === true ? 'true' : 'false',
      };
    },
    toDto: (formState: SetupUserFormState): UpdateRequest<SetupUserFormState> => {
      // @ts-ignore
      return {
        body: {
          email: formState.email,
          roleIds: formState.roleIds,
          isProviderUsersAdmin: formState.isProviderUsersAdmin,
          allowedRoleIds: formState.allowedRoleIds,
          password: formState.password,
          providerRgs: formState.providerRgs,
        },
      };
    },
  };
};
